import { TaskStatus } from '../../definition'

const getTaskStatus = (status?: TaskStatus, techIsDeactiveAndTaskEditable?: boolean) => {
  let cssStatus = 'new-booking'
  let statusLabel = 'New Booking'

  if (status === TaskStatus.CREATED) {
    cssStatus = 'new-booking'
    statusLabel = 'New Booking'
  } else if (status === TaskStatus.REASSIGN || techIsDeactiveAndTaskEditable) {
    cssStatus = 're-assigned'
    statusLabel = 'Reassign Required'
  } else if (status === TaskStatus.ASSIGNED) {
    cssStatus = 'assigned'
    statusLabel = 'Assigned'
  } else if (status === TaskStatus.ON_THE_WAY) {
    cssStatus = 'on-the-way'
    statusLabel = 'On The Way'
  } else if (status === TaskStatus.STARTED) {
    cssStatus = 'task-started'
    statusLabel = 'Task started'
  } else if (status === TaskStatus.DONE) {
    cssStatus = 'completed'
    statusLabel = 'Completed'
  } else if (status === TaskStatus.COMPLETED) {
    cssStatus = 'finalising'
    statusLabel = 'Finalising'
  } else if (status === TaskStatus.CANCELED) {
    cssStatus = 'canceled'
    statusLabel = 'Canceled'
  } else if (status === TaskStatus.RESCHEDULE) {
    cssStatus = 'reschedule'
    statusLabel = 'Reschedule Required'
  }

  return { cssStatus, statusLabel }
}

export default getTaskStatus
